import actionCreatorFactory, { ActionCreator, Failure, Success } from 'typescript-fsa'
import { createContact as createContactApi } from '../../firebase'
import wrapAsyncWorker from '../../wrapAsyncWorker'

const actionCreator = actionCreatorFactory()

const CREATE_CONTACT = 'CREATE_CONTACT'

export interface CreateContactParams {
	questionType: string
	companyName: string
	staffName: string
	email: string
	telephone: string
	createdAt: number
}

interface CreateSuccessResponse {
	message: string
}

interface CreateFailureResponse {
	message: string
}

interface CreateContactAsyncActions {
	start: ActionCreator<CreateContactParams>
	done: ActionCreator<Success<CreateContactParams, CreateSuccessResponse>>
	failure: ActionCreator<Failure<CreateContactParams, CreateFailureResponse>>
}
const createContact = actionCreator
	.async<CreateContactParams, CreateSuccessResponse, CreateFailureResponse>(CREATE_CONTACT)

export const createClipAsyncAction: CreateContactAsyncActions = {
	start: createContact.started,
	done: createContact.done,
	failure: createContact.failed
}

export const createContactWorker = wrapAsyncWorker<CreateContactParams, CreateSuccessResponse, CreateFailureResponse>(
	createContact,
	(params: CreateContactParams): Promise<CreateSuccessResponse> => {
		return new Promise<CreateSuccessResponse>(async (resolve, reject) => {
			try {
				await createContactApi(params)
				resolve({ message: '登録に成功しました' })
			} catch (error) {
				reject({ message: '登録に失敗しました' })
			}
		})
	}
)


// WEBPACK FOOTER //
// ./src/actions/contacts/index.ts